import { ID_VETERINARIO_OFICIAL } from "@/contexts/autorizacao/perfil";
import { useUsuarioLogado } from "@/contexts/autorizacao/usuario";
import { useEstabelecimento } from "@/contexts/cadastro/estabelecimento";
import { createFormularioApi } from "@/contexts/fiscalizacao/formulario/api/formularioApi";
import { Formulario } from "@/contexts/fiscalizacao/formulario/model/Formulario";
import {
  formularioAction,
  getFormularioSynced,
} from "@/contexts/fiscalizacao/formulario/store/formularioSlice";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useFormulario = () => {
  const { user } = useAuth();
  const formularioApi = createFormularioApi(user?.access_token);
  const listaFormularios = useSelector(getFormularioSynced);
  const appDispatch = useDispatch();
  const { sync } = formularioAction;
  const { listaEstabelecimentos } = useEstabelecimento();
  const { usuarioLogado } = useUsuarioLogado();

  const sincronizarFormularios = (formularios: Formulario[]) => {
    appDispatch(sync(formularios));
  };

  const getFormulariosApi = formularioApi.listAll;

  const getFormulariosForPerfil = (estabelecimentoId: number) => {
    if (usuarioLogado.perfil.id === 1) {
      return listaFormularios.filter(
        (form) => form.tipoFormulario === "AUDITORIA"
      );
    }

    const estabelecimento = listaEstabelecimentos.find(
      (e) => e.id === estabelecimentoId
    );

    const pessoaInspecao = estabelecimento?.pessoasInspecao.find(
      (pi) => pi.id === usuarioLogado.pessoaId
    );

    if (!pessoaInspecao) {
      return [];
    }

    if (pessoaInspecao.funcao.id === ID_VETERINARIO_OFICIAL) {
      return listaFormularios.filter(
        (form) => form.tipoFormulario === "MONITORIA"
      );
    }

    if (pessoaInspecao.inspetor) {
      return listaFormularios.filter(
        (form) => form.tipoFormulario === "INSPETOR"
      );
    }

    return [];
  };

  return {
    getFormulariosApi,
    sincronizarFormularios,
    listaFormularios,
    getFormulariosForPerfil,
  };
};
